import request from '../../requests/requests';
import { Api } from '../../config/api';
import { configs } from '../../config/config';


export function getDeviceByImei(data){
    return request({
        url:Api.device.device_imei,
        method:configs.http.request.methodPost,
        data
    })
}


export function lock(data){
    return request({
        url:Api.device.device_lock,
        method:configs.http.request.methodPost,
        data
    })
}

export function unLock(data){
    return request({
        url:Api.device.device_unlock,
        method:configs.http.request.methodPost,
        data
    })
}

export function factoryReset(data){
    return request({
        url:Api.device.factory,
        method:configs.http.request.methodPost,
        data
    })
}

export function eraseCID(data){
    return request({
        url:Api.device.eraseCID,
        method:configs.http.request.methodPost,
        data
    })
}

export function RefreshPing(data){
    return request({
        url:Api.device.ping,
        method:configs.http.request.methodPost,
        data
    })
}

export function createDevice(data){
    return request({
        url:Api.device.device_bind,
        method:configs.http.request.methodPost,
        data
    })
}

export function exportDeviceByCustomId(data){
    return request({
        url:Api.device.export,
        method:configs.http.request.methodPost,
        data
    })
}

export function ImportDevice(data){
    return request({
        url:Api.device.import,
        method:configs.http.request.methodPost,
        data
    })
}

export function ClearActivationDate(data){
    return request({
        url:Api.device.clearActivation,
        method:configs.http.request.methodPost,
        data
    })
}

export function PermanentlyLock(data){
    return request({
        url:Api.device.permanentlyLock,
        method:configs.http.request.methodPost,
        data
    })
}

export function editDevice(data){
    return request({
        url:Api.device.edit,
        method:configs.http.request.methodPost,
        data
    })
}

export function stopFactoryReset(data){
    return request({
        url:Api.device.stop_factory,
        method:configs.http.request.methodPost,
        data
    })
}